module.exports = __webpack_public_path__ + "img/1568362784.9748e949.jpg";